<template>
	<section>
		<div class="pcMaxW imgContainer">
			<img :src="banner" />
			
			<section class="pt-5">
				<div class="pcMaxW bgDark p-5 container">
					<div class="dFlex alCenter jcBetween title mb-3">
						<h5 class="m-0 fw-normal">聯繫我們</h5>
					</div>
					<div class="textWhite50">
						<p class="mb-2">公司：Pomelo Co., Limited</p>
						<p class="mb-2">郵箱：pomelocolimited@gmail.com</p>
						<p class="mb-2">電話：+852 9736 3878</p>
						<p class="mb-2">地址：RM 101A, 1/F., GENPLAS IND BUILDING, 56 HOI YUEN ROAD,
KWUN TONG
HONG KONG</p>
					</div>
				</div>
			</section>
		</div>
	</section>
	
</template>

<script setup>
	import { ref,onMounted,getCurrentInstance } from 'vue'
	const banner = ref(require('@/assets/images/hongkong_000.png'))
</script>

<style lang="less" scoped>
	.imgContainer{
		overflow: hidden;
		img{
			width: 100%;vertical-align: middle;border-radius: 23px;
		}
	}
</style>